import { affiliateIds, mycroftAffiliateIds } from 'constants/affiliates';
import { AffiliateClients, AffiliateFields, FieldByUuid, JohnDeereField } from 'store/types/types';
import { getIdsSortedByName } from 'util/getIdsSortedByName';
import { AffiliateList, DeereWorkPlans, JohnDeereWorkPlan, RawJohnDeereField, RawJohnDeereFields } from './types';

const deereInitialState = {
  selectedOrganization: '',
  clients: {
    byName: {},
    ids: []
  },
  fields: {
    byId: {},
    byClient: {},
    ids: []
  },
  workPlans: {
    byScriptId: {}
  }
};

export const parseAffiliateList = (affiliateList: AffiliateList) => {
  const affiliates = {
    connections: []
  };
  affiliateList.affiliates.forEach( (entry) => {
    const name = entry.affiliate;
    affiliates[name] = name === mycroftAffiliateIds[affiliateIds.MYJD] ? deereInitialState: {};
    affiliates[name].organizations = entry.organizations || [];
    if(affiliates[name].organizations.length === 1) {
      affiliates[name].selectedOrganization = entry.organizations[0].id;
    }
    affiliates.connections.push(name);
  });
  return affiliates;
};

export const parseJohnDeereFields = (rawJohnDeereFields: RawJohnDeereFields, fvFields: FieldByUuid) => {

  const parsedFields = rawJohnDeereFields
  .reduce((accumulatedResults, { results }) => accumulatedResults.concat(results), [] as RawJohnDeereField[])
  .reduce((parsedFields, { id, fieldName, orgId, clientName }) => {
    parsedFields.fields.byId[id] = {
      id,
      name: fieldName,
      organizationId: orgId,
      clientName,
      fvFieldUuid: Object.values(fvFields).find(({ name }) => name === fieldName)?.uuid || null
    };

    if (!parsedFields.clients.byName[clientName]) {
      parsedFields.clients.byName[clientName] = {
        id: clientName,
        name: clientName
      };
    }

    return parsedFields;
  }, { fields: { byId: {} }, clients: { byName: {} } } as { fields: AffiliateFields; clients: AffiliateClients });

  parsedFields.fields.ids = getIdsSortedByName(parsedFields.fields.byId);
  parsedFields.clients.ids = getIdsSortedByName(parsedFields.clients.byName);
  parsedFields.fields.byClient = Object.values(parsedFields.fields.byId)
  .reduce((fieldsByClient, field) => {
    fieldsByClient[field.clientName] = [...(fieldsByClient[field.clientName] || []), field];

    return fieldsByClient;
  }, {});

  Object.keys(parsedFields.fields.byClient).forEach((clientName) => {
    parsedFields.fields.byClient[clientName] = parsedFields.fields.byClient[clientName]
    .toSorted((fieldA, fieldB) =>
      (fieldA as unknown as JohnDeereField).name.localeCompare((fieldB as unknown as JohnDeereField).name))
    .map((field) => (field as unknown as JohnDeereField).id);
  });

  return parsedFields;
};

export const parseJohnDeereWorkPlans = ({ results = [] }: DeereWorkPlans) => {
  const byScriptId: { [key: string]: JohnDeereWorkPlan } = {};
  results.forEach(({
    rxId: scriptId,
    workPlanId,
    fvFieldId,
    jdFieldId,
    uri,
    createdAt,
    updatedAt,
    state
  }) => {
    if (state !== 'FAILED'
      && (!byScriptId[scriptId] || new Date(createdAt) > new Date(byScriptId[scriptId].createdAt))) {
      byScriptId[scriptId] = {
        id: workPlanId,
        scriptId,
        fieldUuid: fvFieldId,
        jdFieldId: jdFieldId,
        url: uri,
        createdAt,
        updatedAt,
        state
      };
    }
  });

  return byScriptId;
};
